export const language: any = {
    LabelCarts: "Einkaufswagen",
    Material: "Material",
    nodata: "Keine Daten im Warenkorb",
};